import { render, staticRenderFns } from "./BtnetNavList.vue?vue&type=template&id=437c0b0c&"
import script from "./BtnetNavList.vue?vue&type=script&lang=js&"
export * from "./BtnetNavList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports